import { Badge, Tooltip } from "@shopify/polaris";

// Verification state of a provider's CLABE, as reported by the banking system
// (not by whatever someone typed into our database).
//
// `clabe_status` values come from bank_account_verifications.match_result:
//   verified | name_mismatch | rfc_mismatch | failed | queued | pending | null
function ClabeBadge({ status, holderName }) {
  const badge = (() => {
    switch (status) {
      case "verified":
        return <Badge tone="success">Verificado</Badge>;
      // Deliberately not the same badge as a bank-confirmed account: someone
      // overruled the bank, so it is yellow, and the hover says so.
      case "verified_override":
        return <Badge tone="attention">Verificado</Badge>;
      case "name_mismatch":
        return <Badge tone="critical">Titular no coincide</Badge>;
      case "rfc_mismatch":
        return <Badge tone="critical">RFC no coincide</Badge>;
      case "failed":
        return <Badge tone="critical">Verificación fallida</Badge>;
      case "queued":
      case "pending":
        return <Badge tone="attention" progress="incomplete">Verificando…</Badge>;
      default:
        return <Badge>Sin verificar</Badge>;
    }
  })();

  // The whole point of verification is the name the bank returned, so surface
  // it rather than making someone open the provider to find out.
  if (status === "verified" && holderName) {
    return <Tooltip content={`Titular según el banco: ${holderName}`}>{badge}</Tooltip>;
  }
  if (status === "verified_override") {
    return <Tooltip content="Verificado manualmente">{badge}</Tooltip>;
  }
  if (status === "name_mismatch" && holderName) {
    return <Tooltip content={`El banco reporta: ${holderName}`}>{badge}</Tooltip>;
  }
  return badge;
}

export default ClabeBadge;
